import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IPostState } from '@shared/models';
import * as Response from '@shared/models/post/post.response.type';
import { fetchPostList, fetchSinglePost } from '../queries';

const state: IPostState = {
    list: {
        posts: [],
        count: {
            ALLPOSTS: 0,
            COMPETITIONS: 0,
            CONTENT: 0,
            GENERAL: 0,
            PLATFORM: 0,
            WEBINARS: 0,
        },
    },
    fetchingList: false,
    single: null,
    fetchingSingle: false,
};

const postSlice = createSlice({
    name: 'platform-post',
    initialState: state,
    reducers: {
        setPostList: (state, { payload }: PayloadAction<Response.IFetchPostListResponseType>) => {
            state.list = payload;
        },
        setSinglePost: (state, { payload }: PayloadAction<Response.IFetchSinglePostResponseType>) => {
            state.single = payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchPostList.pending, (state) => {
            state.fetchingList = true;
        });
        builder.addCase(fetchPostList.rejected, (state) => {
            state.fetchingList = false;
        });
        builder.addCase(fetchPostList.fulfilled, (state) => {
            state.fetchingList = false;
        });
        builder.addCase(fetchSinglePost.pending, (state) => {
            state.fetchingSingle = true;
        });
        builder.addCase(fetchSinglePost.rejected, (state) => {
            state.fetchingSingle = false;
        });
        builder.addCase(fetchSinglePost.fulfilled, (state) => {
            state.fetchingSingle = false;
        });
    },
});

export const { setPostList, setSinglePost } = postSlice.actions;
export const postRootReducer = postSlice.reducer;
